import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isReady, trackEvent } from "@/utils/posthog";
import { getShareReferralProperties, parseShareReferral, rememberShareReferral } from "@/utils/promptLibraryShare";

export function usePromptLibraryReferral() {
  const { search, pathname } = useLocation();
  useEffect(() => {
    rememberShareReferral(search);
    if (!parseShareReferral(search)) return;
    let attempts = 0;
    const send = () => {
      if (!isReady()) return false;
      trackEvent("Prompt Library Referred Visit", { ...getShareReferralProperties(), landing_path: pathname });
      return true;
    };
    if (send()) return;
    const timer = window.setInterval(() => {
      if (send() || ++attempts >= 100) window.clearInterval(timer);
    }, 100);
    return () => window.clearInterval(timer);
  }, [search, pathname]);
}
